const asyncRoutes = {
  actions: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-actions-route' */
        'app/developer-v3/routes/actions'
      ).then(module => module.default),
  },
  advanced: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-advanced-route' */
        'app/developer-v3/routes/advanced'
      ).then(module => module.default),
  },
  authentication: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-auth-route' */
        'app/developer-v3/routes/authentication'
      ).then(module => module.default),
  },
  automaticAccountCreation: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-automatic-account-creation-route' */
        'app/developer-v3/routes/automaticAccountCreation'
      ).then(module => module.default),
  },
  contact: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-contact-form' */
        'app/developer-v3/routes/contact'
      ).then(module => module.default),
  },
  createIntegration: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-create-integration-route' */
        'app/developer-v3/routes/createIntegration'
      ).then(module => module.default),
  },
  dashboard: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-dashboard-route' */
        'app/developer-v3/routes/dashboard'
      ).then(module => module.default),
  },
  embed: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-embed-route' */
        'app/developer-v3/routes/embed'
      ).then(module => module.default),
  },
  embedSettings: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-embed-settings-route' */
        'app/developer-v3/routes/embedSettings'
      ).then(module => module.default),
  },
  embedZapEditor: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-embed-zap-editor-route' */
        'app/developer-v3/routes/embedZapEditor'
      ).then(module => module.default),
  },
  history: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-history-route' */
        'app/developer-v3/routes/history'
      ).then(module => module.default),
  },
  home: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-home-route' */
        'app/developer-v3/routes/home'
      ).then(module => module.default),
  },
  insights: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-insights-route' */
        'app/developer-v3/routes/insights'
      ).then(module => module.default),
  },
  issues: {
    fetch: () =>
      Promise.all([
        import(
          /* webpackChunkName: 'developer-v3-issues-route' */
          'app/developer-v3/routes/issues'
        ),
      ]).then(([module]) => module.default),
  },
  joinIntegration: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-join-integration' */
        'app/developer-v3/routes/joinIntegration'
      ).then(module => module.default),
  },
  monitoring: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-monitoring-route' */
        'app/developer-v3/routes/monitoring'
      ).then(module => module.default),
  },
  partnerSettings: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-partner-settings-route' */
        'app/developer-v3/routes/partnerSettings'
      ).then(module => module.default),
  },
  prefilledZaps: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-prefilled-zaps-route' */
        'app/developer-v3/routes/prefilledZaps'
      ).then(module => module.default),
  },
  publishing: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-publishing-route' */
        'app/developer-v3/routes/publishing'
      ).then(module => module.default),
  },
  settings: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-settings-route' */
        'app/developer-v3/routes/settings'
      ).then(module => module.default),
  },
  sharing: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-sharing-route' */
        'app/developer-v3/routes/sharing'
      ).then(module => module.default),
  },
  team: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-team-route' */
        'app/developer-v3/routes/team'
      ).then(module => module.default),
  },
  triggers: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-triggers-route' */
        'app/developer-v3/routes/triggers'
      ).then(module => module.default),
  },
  versions: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-versions-route' */
        'app/developer-v3/routes/versions'
      ).then(module => module.default),
  },
  versionOverview: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-versionOverview-route' */
        'app/developer-v3/routes/versionOverview'
      ).then(module => module.default),
  },
  workflowAPI: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-workflow-api-route' */
        'app/developer-v3/routes/workflowAPI'
      ).then(module => module.default),
  },
  workflowElement: {
    fetch: () =>
      import(
        /* webpackChunkName: 'developer-v3-workflow-element-route' */
        'app/developer-v3/routes/workflowElement'
      ).then(module => module.default),
  },
};

export default asyncRoutes;
